// React
import { memo, useMemo } from "react";

// UI
import { TableSearch } from "ui/components/Table/TableSearch";

// Tipovi i konstante
import { ACTIVITY_COLUMNS } from "./consts";
import { ActivityFeedProps } from "./types";

/** Zadnje aktivnosti kroz sve klijente — iz zapisa aktivnosti, ne iz izmišljenog popisa. */
const ActivityFeed: React.FC<ActivityFeedProps> = (props: ActivityFeedProps) => {
  const { items, tenantNames } = props;

  const columns = useMemo(() => ACTIVITY_COLUMNS(tenantNames), [tenantNames]);

  return (
    <div className="bg-white border border-slate-200 p-4">
      <p className="text-base font-bold text-slate-600 mb-4">Zadnje aktivnosti</p>

      <TableSearch
        columns={columns}
        data={items}
        selectableRows={false}
        disablePagination
      />
    </div>
  );
};

export default memo(ActivityFeed);
